import React from "react";
import "./ShopCarousel.css";
import { outilListe, usePanier } from "../../PanierContext";

const ShopCarousel: React.FC = () => {
  const { ajouterOutil, diminuerOutil, getQuantite } = usePanier();

  // Premier outil = vedette (grande carte), reste = petites cartes
  const [vedette, ...livrets] = outilListe;
  const qtyVedette = getQuantite(vedette.id);

  return (
    <section id="boutique" className="sc">
      <div className="sc__header">
        <h2>Outils de rétablissement</h2>
        <p>Livrets format A5</p>
      </div>

      <div className="sc__masonry">

        {/* Carte vedette — colonne gauche, 2 rangées */}
        <div className="sc__card sc__card--hero">
          <img src={vedette.image} alt={vedette.nom} className="sc__img" loading="lazy" />
          <div className="sc__overlay">
            <div className="sc__overlay-info">
              <span className="sc__name">{vedette.nom}</span>
              <span className="sc__price">{(vedette.prix / 100).toFixed(2)} €</span>
            </div>
            {qtyVedette === 0 ? (
              <button className="sc__add" onClick={() => ajouterOutil(vedette.id)} aria-label={`Ajouter ${vedette.nom}`}>+</button>
            ) : (
              <div className="sc__qty">
                <button className="sc__qty-btn" onClick={() => diminuerOutil(vedette.id)} aria-label="Diminuer">−</button>
                <span>{qtyVedette}</span>
                <button className="sc__qty-btn" onClick={() => ajouterOutil(vedette.id)} aria-label="Augmenter">+</button>
              </div>
            )}
          </div>
        </div>

        {/* Petites cartes — colonne droite */}
        {livrets.map((outil) => {
          const qty = getQuantite(outil.id);
          return (
            <div key={outil.id} className="sc__card sc__card--small">
              <img src={outil.image} alt={outil.nom} className="sc__img" loading="lazy" />
              <div className="sc__overlay">
                <div className="sc__overlay-info">
                  <span className="sc__name">{outil.nom}</span>
                  <span className="sc__price">{(outil.prix / 100).toFixed(2)} €</span>
                </div>
                {qty === 0 ? (
                  <button className="sc__add" onClick={() => ajouterOutil(outil.id)} aria-label={`Ajouter ${outil.nom}`}>+</button>
                ) : (
                  <div className="sc__qty">
                    <button className="sc__qty-btn" onClick={() => diminuerOutil(outil.id)} aria-label="Diminuer">−</button>
                    <span>{qty}</span>
                    <button className="sc__qty-btn" onClick={() => ajouterOutil(outil.id)} aria-label="Augmenter">+</button>
                  </div>
                )}
              </div>
            </div>
          );
        })}

      </div>
    </section>
  );
};

export default ShopCarousel;
